<template>
  <div></div>
</template>

<script>
import { API, ENDPOINTS } from '@/app/services/api-url';

export default {
  name: 'o-auth-view',
  props: {
    code: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      access: null,
    };
  },
  mounted() {
    this.$store.dispatch('toggleLoading', true);
    const callbackURL = this.type === 'bgl' ? process.env.VUE_APP_BGL_CALLBACK_URL : process.env.VUE_APP_CLASS_CALLBACK_URL;
    const accoutUserUUID = this.$store.getters['account/getActiveAccountUser'].uuid;
    API.get(`${ENDPOINTS.GET_BGL_ACCESS_TOKEN}?code=${this.code}&type=${this.type}&redirectUrl=${callbackURL}`)
      .then((res) => {
        API.post(`${ENDPOINTS.POST_ACCOUNTUSER}/${accoutUserUUID}/accesstoken`, {
          token: res.data,
        })
          .then(() => {
            this.$mixpanel.track('integrationSuccess', {
              type: this.type, // bgl, class etc
              accountName: this.$store.getters['account/getActiveAccount'].name,
            });
            this.$router.push({ name: 'account-user-integrations' });
            this.$store.dispatch('toggleLoading', false);
          })
          .catch(err => console.log(err));
      })
      .catch(err => console.log(err))
      .finally();
  },
};
</script>
